import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbItem } from 'src/app/shared/page-title/page-title.model';
import { TranslateService } from '@ngx-translate/core';
import { ProjectSettingService } from '../services/project-setting.service';
import { TableSettingsComponent } from './table-settings/table-settings.component';
import { XMenuItem } from 'src/app/shared/panel-menu/x-menu-item.model';
import { UtilsService } from 'src/app/core/service/utils.service';
import { MegaMenuItem } from 'primeng/api';

export enum MenuSettings {
  Status = "STATUS",
  Priority = 'PRIORITY',
  Event = "EVENT",
  Bug = "BUG",
  Artifact = "ARTIFACT",
  Quotes = "QUOTES",
  Fees = "FEES",
  TeamRoles = "TEAMROLES",
  Notifications = "NOTIFICATIONS",
  Emails = "EMAILS",
  SubRoles = "SUBROLES",
  Column = "COLUMN"
}

@Component({
  selector: 'app-project-settings',
  templateUrl: './project-settings.component.html',
  styleUrls: ['./project-settings.component.scss']
})
export class ProjectSettingsComponent implements OnInit {

  @ViewChild('settings') settings: TableSettingsComponent | null = null;

  projectId: number;
  settingMenu: MegaMenuItem[];
  settingType: string;

  constructor(protected activeRoute: ActivatedRoute,
    protected translate: TranslateService,
    protected settingSrv: ProjectSettingService,
    protected utilSrv: UtilsService) {
    this.projectId = this.activeRoute.snapshot.params.projectId;
  }

  ngOnInit(): void {
    this.setSettingMenu();
    this.settingType = MenuSettings.Priority
    this.settings?.updateType(this.settingType);
  }

  get pageTitle(): BreadcrumbItem[] {
    return [
      { label: 'PROJECTS.SIDEBAR.PROJECTLIST', path: '/projects/list' },
      { label: 'PROJECTS.SIDEBAR.SETTINGS', active: true }
    ];
  }

  setSettingMenu() {
    this.settingMenu = [
      {
        label: this.translate.instant('SETTINGS.TAB.SETTINGS'),
        icon: 'mdi mdi-cog',
        items: [
          [
            {
              label: this.translate.instant('SETTINGS.TAB.SETTINGS'),
              items: [
                {
                  label: this.translate.instant('SETTINGS.COLLAPSE.PRIORITY'),
                  icon: 'mdi mdi-format-list-numbered',
                  command: () => {
                    this.settingType = MenuSettings.Priority
                    this.settings?.updateType(this.settingType);
                  },
                },
                {
                  label: this.translate.instant('SETTINGS.COLLAPSE.EVENT'),
                  icon: 'mdi mdi-calendar',
                  command: () => {
                    this.settingType = MenuSettings.Event
                    this.settings?.updateType(this.settingType);
                  },
                },
                {
                  label: this.translate.instant('SETTINGS.COLLAPSE.BUG'),
                  icon: 'mdi mdi-bug',
                  command: () => {
                    this.settingType = MenuSettings.Bug
                    this.settings?.updateType(this.settingType);
                  },
                },
                {
                  label: this.translate.instant('SETTINGS.COLLAPSE.ARTIFACT'),
                  icon: 'mdi mdi-pencil-ruler',
                  command: () => {
                    this.settingType = MenuSettings.Artifact
                    this.settings?.updateType(this.settingType);
                  },
                },
                {
                  label: this.translate.instant('SETTINGS.COLLAPSE.COLUMN'),
                  icon: 'mdi mdi-table-edit',
                  command: () => {
                    this.settingType = MenuSettings.Column
                    this.settings?.updateType(this.settingType);
                  },
                },
              ]
            }

          ],
        ]
      }
    ];
  }

}
